import { useMatches } from 'react-router';

import { routeById, viewOf, type AppView } from './registry';

/** Which product the page being shown belongs to, from the deepest matched route. */
export function useCurrentView(): AppView {
  const matches = useMatches();
  for (let i = matches.length - 1; i >= 0; i -= 1) {
    const routeId = (matches[i]!.handle as { routeId?: string } | undefined)?.routeId;
    if (routeId) return viewOf(routeById.get(routeId));
  }
  return 'analyst';
}
